
import { defineComponent, reactive, ref } from "vue";
import { CreateGatewayModalType } from "@/types/components";
import { openNotificationWithIcon, getErrorMessage } from "@/composables/utils";
import { ipAddressValidation } from "@/composables/validations";
import { createGateway } from "@/composables/api";
import { Modal, Input, Form, FormItem } from "ant-design-vue";
import type { FormInstance } from "ant-design-vue";
import "ant-design-vue/lib/modal/style/css";
import "ant-design-vue/lib/input/style/css";
import "ant-design-vue/lib/form/style/css";

export default defineComponent({
  name: "CreateGatewayModal",
  components: {
    Modal,
    AInput: Input,
    AForm: Form,
    AFormItem: FormItem,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, ctx) {
    const formRef = ref<FormInstance>();
    const data = reactive<CreateGatewayModalType>({
      uniqueSerialNumber: "",
      address: "",
      label: "",
      isLoading: false,
    });
    const emitCloseEvent = () => {
      if (data.isLoading) return;
      formRef.value?.resetFields();
      ctx.emit("close");
    };
    const onCreateGateway = async () => {
      try {
        data.isLoading = true;
        await createGateway(data.uniqueSerialNumber, data.address, data.label);
        openNotificationWithIcon("success", "Gateway succesfully created");
        formRef.value?.resetFields();
        ctx.emit("success");
      } catch (error) {
        const message = getErrorMessage(error);
        openNotificationWithIcon(
          "error",
          "Gateway couldn´t be created",
          message
        );
      } finally {
        data.isLoading = false;
      }
    };

    const fieldsValidation = async () => {
      try {
        await formRef.value?.validateFields();
        await onCreateGateway();
      } catch (error) {
        console.log("Validation error info: ", error);
      }
    };
    return {
      props,
      emitCloseEvent,
      data,
      fieldsValidation,
      formRef,
      ipAddressValidation,
    };
  },
});
